import React from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '../../data/mock';
import { VIC_HOME_FAQS } from '../../data/vicHomeFaqs';
import { ArrowRight } from 'lucide-react';
import { useUserState } from '../../lib/userState';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

// Homepage shows a curated subset aimed at a brand-new anonymous visitor
// (what is this, does it cover me, is it trustworthy, do I keep control, no
// signup). Deeper paid-plan FAQs (Core vs Premium, Quote Comparison, Platinum)
// are intentionally omitted here - they live on the pricing/Platinum pages and
// still render in the full `faqs` list used by other pages.
const HOMEPAGE_FAQ_QUESTIONS = [
  'Is BuildPilot only for new homes?',
  'How does BuildPilot rank builders?',
  'Which states does BuildPilot cover?',
  'How do you verify builders?',
  'Can I save my build brief and pick up later?',
  'Can I choose my own builder?',
];

const FAQSection = () => {
  const userState = useUserState();
  const isVic = userState === 'VIC';
  const items = isVic
    ? VIC_HOME_FAQS
    : faqs.filter((f) => HOMEPAGE_FAQ_QUESTIONS.includes(f.question));
  const eyebrow = isVic ? 'Building in Victoria' : 'Got Questions?';
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white" data-testid="home-faq-section" data-faq-state={userState}>
      <div className="max-w-[680px] mx-auto px-5 sm:px-6">
        {/* Section Header - matching app site mobile typography */}
        <div className="text-center mb-6 sm:mb-14 lg:mb-16">
          <h2 className="text-[26px] sm:text-[34px] lg:text-[40px] font-semibold text-[#1d1d1f] leading-[1.1] tracking-[-0.02em]">
            {isVic ? 'Victoria FAQs' : 'FAQs'}
          </h2>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="divide-y divide-[#d2d2d7]">
          {items.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border-0"
            >
              <AccordionTrigger className="text-left text-[15px] sm:text-[17px] font-semibold text-[#1d1d1f] hover:no-underline py-4 sm:py-5 hover:text-[#1d8efe] transition-colors duration-300">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-[14px] sm:text-[15px] text-[#86868b] pb-4 sm:pb-5 leading-[1.5]">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA */}
        <div className="text-center mt-10 sm:mt-14 lg:mt-16">
          <p className="text-[14px] sm:text-[15px] text-[#86868b] mb-3 sm:mb-4">Still have questions?</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-1.5 text-[#1d8efe] hover:underline font-normal text-[15px] sm:text-[17px] transition-all group"
          >
            Contact us
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;